import { useConfigForm } from './configuration/useConfigForm';
import { ConfigForm } from './configuration/ConfigForm';
import { ConfigModalHeader } from './configuration/ConfigModalHeader';
import { ConfigModalFooter } from './configuration/ConfigModalFooter';

function ConfigurationModal({ isOpen, onClose, fullScreen = false }) {
  const {
    config,
    setConfig,
    isLoading,
    isSaving,
    successMessage,
    countdown,
    isConnected,
    saveConfig,
    handleGetStarted
  } = useConfigForm(isOpen, fullScreen, onClose);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen && !fullScreen) {
    return null;
  }

  const LoadingSpinner = () => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px',
      color: '#6b7280',
      fontSize: '14px'
    }}>
      <div style={{
        width: '20px',
        height: '20px',
        border: '2px solid #e5e7eb',
        borderTopColor: '#3B82F6',
        borderRadius: '50%',
        marginRight: '12px',
        animation: 'spin 0.8s linear infinite'
      }} />
      Loading configuration...
    </div>
  );

  // Full screen mode - render as a full page, not a modal
  if (fullScreen) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: '#f9fafb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000
        }}
      >
        <div
          style={{
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '80vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <ConfigModalHeader onClose={onClose} showCloseButton={false} />

          <div style={{
            padding: '20px',
            overflowY: 'auto',
            flex: 1
          }}>
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <ConfigForm
                config={config}
                setConfig={setConfig}
                isConnected={isConnected}
                successMessage={successMessage}
                countdown={countdown}
              />
            )}
          </div>

          {!isLoading && isConnected && (
            <ConfigModalFooter
              onSave={handleGetStarted}
              isSaving={isSaving}
              successMessage={successMessage}
              fullScreen={true}
            />
          )}
        </div>

        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        animation: 'fadeIn 0.15s ease-in'
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
          width: '90%',
          maxWidth: '600px',
          maxHeight: '80vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          animation: 'slideUp 0.2s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <ConfigModalHeader onClose={onClose} showCloseButton={true} />

        <div style={{
          padding: '20px',
          overflowY: 'auto',
          flex: 1
        }}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <ConfigForm
              config={config}
              setConfig={setConfig}
              isConnected={isConnected}
              successMessage={successMessage}
              countdown={countdown}
            />
          )}
        </div>

        {!isLoading && (
          <ConfigModalFooter
            onSave={saveConfig}
            onCancel={onClose}
            isSaving={isSaving}
            successMessage={successMessage}
            fullScreen={false}
          />
        )}
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default ConfigurationModal;
